const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/members/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/members/$")({
  beforeLoad: () => {
    redirect({
      to: "/members",
      replace: true,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});